export default __webpack_public_path__ + "static/media/bootstrap-cheatsheet.a70c7203.png";